module.exports = __webpack_public_path__ + "img/hiper.c.c605e1d9.png";